import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonNote, IonPage, IonTextarea, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import BeautyStars from "beauty-stars";
import { alertCircle, arrowBack } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { avaliarProjeto, requestService, urlBase } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./OrdensAvaliar.css";

type Props = {
  projetoid: string;
  comentario: string;
  estrelas: string;
  onDismiss: () => void;
};


const OrdensAvaliar: React.FC<Props> = (props: Props) => {


  const history = useHistory<any>();
  const location = useLocation<any>();
  const [alertaPreenchimento, setAlertaPreenchimento] = useState(false);
  const [valorEstrela, setValorEstrela] = useState(0);
  const [textoEstrela, setTextoEstrela] = useState("Selecione");
  const [comentario, setComentario] = useState("");
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    carregarProjeto();
    setEsconderMenu(true);

  });

  function carregarProjeto() {
    if (params.projetoid != "" && params.projetoid != undefined) {
      if (!chamadaRealizada) {
        setChamadaRealizada(true);

        var token: string = "";
        var tkn = localStorage.getItem("token");
        if (typeof (tkn) === "string") { token = tkn; }
        console.log("projetoid", params.projetoid);
        const getoperacao = async () => {
          const resp = await fetch(urlBase.url + "/mobile/ordens/" + params.projetoid.replaceAll(/#/g, '%23'),
            {
              method: urlBase.method,
              headers: [
                ["token", token],
                ["perfil", window.localStorage.getItem("perfil") || ""],
                ["marca", window.localStorage.getItem("marca") || ""],
              ],
              credentials: 'include'
            });
          const operacao = await resp.json();
          //if (resp.status === 400 || resp.status === 401) history.replace("/primeiroacesso/");
          if (operacao.Item !== undefined) {
            console.log("operacao.Item", operacao.Item);
            setComentario(operacao.Item.comentarioCliente);
            setValorEstrela(operacao.Item.avaliacaoCliente);
          }

        }

        getoperacao();
      }
    }
  }

  let params: any = {
    projetoid: "",
    comentario: "",
    estrelas: "",
  }
  params = useParams();

  if (location && location.state && location.state.projetoid) {
    params.projetoid = location.state.projetoid;
    params.comentario = location.state.comentario;
    params.estrelas = location.state.estrelas;
  }


  if (props.projetoid) {
    params = {
      projetoid: props.projetoid,
      comentario: props.comentario,
      estrelas: props.estrelas
    }
  }




  function ajustaTextoEstrela(value: any) {
    if (value === 1) setTextoEstrela("Muito ruim");
    if (value === 2) setTextoEstrela("Ruim");
    if (value === 3) setTextoEstrela("Normal");
    if (value === 4) setTextoEstrela("Bom");
    if (value === 5) setTextoEstrela("Excelente");
  }

  function avaliar() {
    const atualizar = async () => {
      requestService(avaliarProjeto.url, {
        method: avaliarProjeto.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        body: JSON.stringify({
          "id": params.projetoid,
          "avaliacao": valorEstrela + "",
          "comentario": comentario ? comentario + "" : "Sem comentário."
        }),
        credentials: 'include'
      },
        history,
        (response: any) => {
          if (response.message) {
            console.log(response);
            history.goBack();
          }
        },
        (error: any) => {
          console.log(error);
        });
    }

    if (valorEstrela !== 0) {
      setAlertaPreenchimento(false);
      atualizar();
    }
    else {
      setAlertaPreenchimento(true);
    }

  }


  return (

    <IonPage className="OrdensAvaliar">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonTitle>Avaliar</IonTitle>
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen={false}>


        <IonItem lines="none">
          <IonIcon hidden={!alertaPreenchimento} src={alertCircle} color="danger" slot="end" />
          <IonNote hidden={!alertaPreenchimento} color="danger" slot="end" style={{ "font-size": "14px" }} >Campo obrigatório</IonNote>
        </IonItem>
        <IonItem lines="none">
          <IonLabel>Escolha de 1 a 5 estrelas para avaliar</IonLabel>

        </IonItem>
        <IonItem lines="full" style={{ "margin-bottom": "20px" }}>
          <div className="avaliarComentar">
            <div className="avaliacaoEstrela">
              <BeautyStars
                value={valorEstrela}
                onChange={value => { setAlertaPreenchimento(false); setValorEstrela(value); ajustaTextoEstrela(value); }}
                editable={true}
              />
            </div>
          </div>
        </IonItem>
        <IonItem lines="none">
          <IonLabel>
            Deixar comentário
          </IonLabel>
        </IonItem>
        <IonItem lines="none">
          <IonTextarea rows={3}
            value={comentario}
            style={{ "margin": "5px", "padding": "5px", "border-width": "1px", "border-style": "solid", "border-color": "#e0e0e0", "margin-top": "10px", "margin-right": "10px", "background": "#f2f2f2" }}
            placeholder="Conte-nos o que aconteceu (opcional)"
            onIonChange={e => setComentario(e.detail.value!)}>
          </IonTextarea>
        </IonItem>

      </IonContent>
      <IonFooter className="ion-no-border">
        <IonToolbar >
          <IonButton expand="block" onClick={() => { avaliar() }} >Avaliar</IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );


};

export default OrdensAvaliar;